import axios, { AxiosResponse } from 'axios';

import { ProductsResponse, SearchResults } from '../utils/models/search';

// TODO customer account number

export const getSearchResults = (query: string, customerAccount: string): Promise<AxiosResponse<SearchResults>> => {
    return axios.post(`/apps/berardi/products/search?locale=it`, {
        search: query,
        customerAccount: customerAccount,
    });
};

export const getProductData = (productIds: string[]): Promise<AxiosResponse<ProductsResponse>> => {
    const productsQuery = productIds.join(' OR ');
    // const productsQuery = productIds.map((id) => `id:${id}`).join(' OR ');

    const variables = {
        first: 20,
        query: productsQuery,
        maxHeight: 300,
        maxWidth: 300,
    };

    const graphqlQuery = {
        query: `query searchProducts($query: String, $first: Int, $maxWidth: Int, $maxHeight: Int) {
                products(query: $query,first: $first, ) {
                    edges {
                    cursor
                    node {
                        title
                        handle
                        metafields(identifiers : [{namespace: "filters", key: "din"}, {namespace: "filters", key: "uni"}, {namespace: "filters", key: "iso"}]) {
                            reference {
                                ... on Metaobject {
                                    field(key: "value") {
                                        value
                                    }
                                }
                            }
                        }
                        featuredImage {
                        transformedSrc(maxWidth: $maxWidth, maxHeight: $maxHeight)
                        }
                    }
                    }
                }
            }`,
        variables: variables,
    };

    const endpoint = 'https://dev-berardi.myshopify.com/api/2024-10/graphql.json';
    const headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '57bf245536f2071e9ece7574e51aa0ce',
    };

    const response = axios.post(endpoint, graphqlQuery, { headers: headers });

    return response;
};
